import React from 'react';
import OffWrap from '../../components/Layout/Header/OffWrap';
import Header from '../../components/Layout/Header/Header';
import Footer from '../../components/Layout/Footer/FooterStyleOne';
import SearchModal from '../../components/Layout/Header/SearchModal';
import Newsletter from '../../components/Common/Newsletter';
import SiteBreadcrumb from '../../components/Common/Breadcumb';

// Reuse existing home sections
import ServicesGridSection from '../home/ServicesGridSection';
import ServiceSection from '../home/ServiceSection';

// Images
import Logo from '../../assets/img/logo/dark-logo.png';
import footerLogo from '../../assets/img/logo/lite-logo.png';
import bannerbg from '../../assets/img/breadcrumbs/2.jpg';

const ServicesMain = () => {
  return (
    <React.Fragment>
      <OffWrap />
      <Header
        parentMenu="services"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
        CanvasLogo={Logo}
        mobileNormalLogo={Logo}
        CanvasClass="right_menu_togle hidden-md"
        headerClass="full-width-header header-style1 home8-style4"
        TopBar='enable'
        TopBarClass="topbar-area home8-topbar"
        emailAddress='hello@syroltech.com'
        Location='Abuja, Nigeria'
      />

      {/* Breadcrumb */}
      <SiteBreadcrumb
        pageTitle="Our Services"
        pageName="Services"
        breadcrumbsImg={bannerbg}
      />

      {/* Main Services Sections */}
      <div className="pt-90 md-pt-60 pb-60 md-pb-40">
        <div className="container">
          {/* Overview section reused from home */}
          <ServiceSection />
        </div>
      </div>

      {/* Services Grid */}
      <ServicesGridSection />

      <Newsletter
        sectionClass="rs-newsletter style1 orange-color mb--90 sm-mb-0 sm-pb-70"
        titleClass="title mb-0 white-color"
      />

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />
      <SearchModal />
    </React.Fragment>
  );
};

export default ServicesMain;
